module.exports = __webpack_public_path__ + "img/Character_Jean_Thumb.5d4579b3.png";